var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "carousel-form" },
    [
      _c("div", { staticClass: "tip" }, [
        _vm._v(
          "最多可添加10张图片，建议宽度750px；鼠标拖拽左侧圆点可调整图片顺序"
        ),
      ]),
      _vm._v(" "),
      _c("el-divider"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "container" },
        [
          _c(
            "el-form",
            { attrs: { model: _vm.form, "label-width": "70px" } },
            [
              _c(
                "transition-group",
                { attrs: { name: "fade", tag: "div" } },
                _vm._l(_vm.form.banner, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      ref: "formItemRefs",
                      refInFor: true,
                      staticClass: "form-item",
                      class: {
                        dragstart: _vm.dragStartIndex === index,
                        dragging: _vm.dragging === index,
                      },
                      on: {
                        dragend: _vm.dragend,
                        dragover: _vm.dragover,
                        dragenter: function ($event) {
                          return _vm.handleDragenter(index)
                        },
                      },
                    },
                    [
                      _c(
                        "Card",
                        {
                          on: {
                            handleRemove: function ($event) {
                              return _vm.handleRemove(index)
                            },
                            handleDragstart: function (e) {
                              return _vm.dragstart(e, index)
                            },
                          },
                        },
                        [
                          _c("div", { staticClass: "form-item-body" }, [
                            _c(
                              "div",
                              {
                                staticClass: "img-box",
                                on: {
                                  click: function ($event) {
                                    return _vm.upload(index)
                                  },
                                },
                              },
                              [
                                item.pic
                                  ? _c("img", { attrs: { src: item.pic } })
                                  : _c("i", {
                                      staticClass:
                                        "el-icon-camera cameraIconfont",
                                    }),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "form-box" },
                              [
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "标题：" } },
                                  [
                                    _c("el-input", {
                                      attrs: { placeholder: "选填" },
                                      model: {
                                        value: item.name,
                                        callback: function ($$v) {
                                          _vm.$set(item, "name", $$v)
                                        },
                                        expression: "item.name",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-form-item",
                                  { attrs: { label: "链接：" } },
                                  [
                                    _c("JumpNative", {
                                      model: {
                                        value: item.url,
                                        callback: function ($$v) {
                                          _vm.$set(item, "url", $$v)
                                        },
                                        expression: "item.url",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]),
                        ]
                      ),
                    ],
                    1
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "add-btn",
                  attrs: { type: "primary" },
                  on: { click: _vm.addContent },
                },
                [_vm._v("添加内容")]
              ),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("el-divider"),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "展示高度" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.bannerHeight,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "bannerHeight", $$v)
                          },
                          expression: "form.bannerHeight",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticStyle: { "font-size": "13px" } }, [
                        _vm._v("建议banner图片高度与展示高度保持一致"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c("el-divider"),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "左侧" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.bannerPadding.pl,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.bannerPadding, "pl", $$v)
                          },
                          expression: "form.bannerPadding.pl",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "顶侧" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.bannerPadding.pt,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.bannerPadding, "pt", $$v)
                          },
                          expression: "form.bannerPadding.pt",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "右侧" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.bannerPadding.pr,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.bannerPadding, "pr", $$v)
                          },
                          expression: "form.bannerPadding.pr",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "底侧" } },
                    [
                      _c("el-input-number", {
                        attrs: { min: 0 },
                        model: {
                          value: _vm.form.bannerPadding.pb,
                          callback: function ($$v) {
                            _vm.$set(_vm.form.bannerPadding, "pb", $$v)
                          },
                          expression: "form.bannerPadding.pb",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("linkaddressVue", {
        ref: "linkaddressVueRef",
        on: { linkUrl: _vm.linkUrl },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }